const hideSliders = (element) => {
  const activeSection = element.closest('.section');
  const sliders = activeSection.querySelectorAll('.audio__single:not(.active)');

  for (let i = 0; i < sliders.length; i++) {
    const slider = sliders[i];
    slider.style.display = 'none';
  }
};

const showSliders = () => {
  const sliders = document.getElementsByClassName('audio__single');

  for (let i = 0; i < sliders.length; i++) {
    const slider = sliders[i];

    slider.classList.remove('active');
    slider.style.display = 'flex';
  }
};

const openSlider = (element) => {
  const right = element.getElementsByClassName('audio__right')[0];
  right.style.display = 'block';

  setTimeout(() => {
    element.classList.add('active');
    hideSliders(element);
    const mainContainer = element.closest('.section');
    const imageContainer = element.getElementsByClassName('audio__image')[0];
    const image = element.getElementsByTagName('img')[0];
    const trigger = element.querySelectorAll('button[data-trigger]')[0];

    trigger.textContent = 'Close';

    imageContainer.classList.add('active');

    if (mainContainer) {
      mainContainer.classList.add('active');
      mainContainer.scrollIntoView();
    }

    const loaded = () => {
      right.classList.add('active');

      setTimeout(() => {
        const inner = right.getElementsByClassName('audio__right-inner')[0];

        inner.classList.add('active');

        const close = element.getElementsByClassName('audio__close')[0];
        close.addEventListener('click', e => { closeSlider(e.target.closest('.audio__single')); });
      }, 500);
    };

    setTimeout(() => {
      if (image.complete) {
        loaded();
      } else {
        image.addEventListener('load', loaded);
      }
    }, 250);
  }, 0);
};

const openSliderMobile = (element) => {
  console.log('we\'re in the money');
  const right = element.getElementsByClassName('audio__right')[0];
  right.style.display = 'block';

  setTimeout(() => {
    element.classList.add('active');

    const imageContainer = element.getElementsByClassName('audio__image')[0];
    const image = element.getElementsByTagName('img')[0];
    const trigger = element.querySelectorAll('button[data-trigger]')[0];

    trigger.textContent = 'Close';

    imageContainer.classList.add('active');

    const loaded = () => {
      right.classList.add('active');

      setTimeout(() => {
        const inner = right.getElementsByClassName('audio__right-inner')[0];

        inner.classList.add('active');

        const close = element.getElementsByClassName('audio__close')[0];
        close.addEventListener('click', e => { closeSlider(e.target.closest('.audio__single')); });
      }, 500);
    };

    setTimeout(() => {
      if (image.complete) {
        loaded();
      } else {
        image.addEventListener('load', loaded);
      }
    }, 250);
  }, 0);
};

const closeSlider = element => {
  const right = element.getElementsByClassName('audio__right')[0];
  const inner = right.getElementsByClassName('audio__right-inner')[0];
  const trigger = element.querySelectorAll('button[data-trigger]')[0];

  trigger.textContent = 'More';

  inner.classList.remove('active');

  setTimeout(() => {
    right.classList.remove('active');

    setTimeout(() => {
      right.style.display = 'none';
      const mainContainer = element.closest('.section');
      const mq = window.matchMedia('(min-width: 1024px)');
      const imageContainer = element.getElementsByClassName('audio__image')[0];
      imageContainer.classList.remove('active');
      if (mainContainer) {
        mainContainer.classList.remove('active');

        if (mq.matches) {
          element.scrollIntoView();
        }
      }

      showSliders();
    }, 500);
  }, 250);
};

const sliders = () => {
  const triggers = document.querySelectorAll('[data-trigger]');

  for (let i = 0; i < triggers.length; i++) {
    const trigger = triggers[i];
    trigger.addEventListener('click', e => {
      if (e.target.closest('.audio__single').classList.contains('active')) {
        closeSlider(e.target.closest('.audio__single'));
      } else {
        const mq = window.matchMedia('(min-width: 1024px)');

        if(mq.matches) {
          openSlider(e.target.closest('.audio__single'));
        } else {
          openSliderMobile(e.target.closest('.audio__single'));
        }
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  sliders();
});